"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const styling_1 = require("../../styling");
const styles_1 = tslib_1.__importStar(require("./styles"));
const Close_1 = tslib_1.__importDefault(require("../Icons/Close"));
const Portal_1 = tslib_1.__importDefault(require("../Portal"));
function Modal({ open: openProp, onCloseButtonClick, children, classes, title, className = "", }) {
    const [opacity, setOpacity] = (0, react_1.useState)(0);
    const [open, setOpen] = (0, react_1.useState)(openProp);
    const mergedClasses = (0, styling_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styles_1.default }, "modal");
    const opacityRelatedStyles = (0, styles_1.getOpacityRelatedStyles)(opacity);
    (0, react_1.useEffect)(() => {
        if (openProp) {
            setOpen(true);
            setTimeout(() => setOpacity(1), 120);
        }
        else {
            setOpacity(0);
            setTimeout(() => setOpen(false), 120);
        }
    }, [openProp]);
    return (react_1.default.createElement(Portal_1.default, null, open && (react_1.default.createElement("div", { className: mergedClasses === null || mergedClasses === void 0 ? void 0 : mergedClasses.overlay, onClick: onCloseButtonClick, onKeyDown: onCloseButtonClick, role: "button", tabIndex: 0, style: opacityRelatedStyles.overlay },
        react_1.default.createElement("div", { className: `${mergedClasses.root} ${className}`, style: opacityRelatedStyles.root, onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), role: "button", tabIndex: 0 },
            react_1.default.createElement("div", { className: mergedClasses.header },
                react_1.default.createElement("div", { className: mergedClasses.title }, title),
                react_1.default.createElement("button", { type: "button", "aria-label": "Close", onClick: onCloseButtonClick },
                    react_1.default.createElement(Close_1.default, { weight: "normal", className: mergedClasses.closeIcon }))),
            children)))));
}
exports.default = Modal;
//# sourceMappingURL=index.js.map